import Breadcrumb from '../components/Breadcrumb'
import { Helmet } from 'react-helmet'
import Mail from '../components/Mail'
import { initialize } from '../store/pagedata'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

const Apply = () => {
  const dispatch = useDispatch()
  const destination = 'apply@edhrec.com'

  useEffect(() => {
    dispatch(initialize())
  }, [])

  return (
    <>
      <Helmet>
        <meta name='description' content='Apply to write for EDHREC' />
        <meta
          name='keywords'
          content='EDHREC,apply,write,author,article,wordpress'
        />
        <title>Apply | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/apply': 'Apply' }]} />
      <h1 className='page-heading'>Write for EDHREC</h1>
      <Mail
        description={
          <>
            <p>
              EDHREC is always on the lookout for new perspectives to add to our
              talented roster of contributors. We do not publish ad hoc articles
              or deck techs at this time but we are interested in prospective
              authors who have an idea for a series of articles with a central
              theme.
            </p>
            <p>
              If you have an idea for a novel and innovative series, complete
              this form or email your pitch to{' '}
              <a
                href={`mailto:${destination}`}
                rel='noreferrer'
                target='_blank'
              >
                {destination}
              </a>
              . Good pitches will contextualize or incorporate EDHREC data.
              Excellent pitches will also be free from spelling and grammar
              mistakes.
            </p>
          </>
        }
        destination={destination}
      />
    </>
  )
}

export default Apply
